import { ReactElement, useEffect, useState } from 'react';
import {
  Box,
  Card,
  // CardContent,
  CardHeader,
  CircularProgress,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
// import VulnerabilitiesByRiskRating from './VulnerabilitiesByRiskRating';
// import ResidualRiskDistribution from './ResidualRiskDistribution';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { useNavigate } from 'react-router-dom';
import { RiskAssessmentService } from 'services/RiskAssessmentService';

const AIRiskManagement = (): ReactElement => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [statusCount, setStatusCount] = useState({
    totalCount: 0,
    completedCount: 0,
    inProgressCount: 0,
    assessmentOnAI: 0,
  });
  // const { riskRegister, vulnerabilities } = props;
  // type RiskLevel = 'Low' | 'Medium' | 'High' | 'Critical';

  // const vulnerabilityData = vulnerabilities
  //   ? Object.entries(vulnerabilities).map(([key, value]) => ({
  //       rating: key as RiskLevel,
  //       count: Number(value),
  //     }))
  //   : null;

  // const residualData = riskRegister?.counts
  //   ? Object.entries(riskRegister.counts).map(([key, value]) => ({
  //       level: (key === 'Moderate' ? 'Medium' : key) as RiskLevel,
  //       count: Number(value),
  //     }))
  //   : null;

  // const totalRisks = residualData
  //   ? residualData.reduce((sum, item) => sum + item.count, 0)
  //   : 0;

  const loadRiskAssessments = (): void => {
    setIsLoading(true);
    RiskAssessmentService.getExternalAssessments(
      `offset=1&limit=100&assessmentType=self&sort=asc`
    )
      .then((response) => {
        const { data } = response.data;
        const { assessment } = data;
        const { totalCount, completedCount, assessmentOnAI, inProgressCount } =
          assessment;
        setStatusCount({
          totalCount,
          completedCount,
          assessmentOnAI,
          inProgressCount,
        });
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    loadRiskAssessments();
  }, []);

  if (isLoading) {
    <Box className="empty-content">
      <CircularProgress />
    </Box>;
  }
  return (
    <Card variant="outlined">
      <CardHeader
        title="AI Risk Management"
        subheader="Overview of your AI system vulnerabilities and risk"
        action={
          <IconButton
            onClick={() => {
              navigate(`/risk-assessments`);
            }}
          >
            <RemoveRedEyeIcon />
          </IconButton>
        }
      />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} lg={3}>
          <Card
            variant="outlined"
            sx={{
              padding: '16px',
              borderRadius: '12px',
            }}
          >
            <Box sx={{ mb: 2 }}>
              <Typography variant="h6">Total assessments</Typography>
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 'bold',
                fontSize: '24px',
              }}
            >
              {statusCount.totalCount}
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <Card
            variant="outlined"
            sx={{
              padding: '16px',
              borderRadius: '12px',
            }}
          >
            <Box sx={{ mb: 2 }}>
              <Typography variant="h6">Completed</Typography>
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 'bold',
                fontSize: '24px',
              }}
            >
              {statusCount.completedCount}
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <Card
            variant="outlined"
            sx={{
              padding: '16px',
              borderRadius: '12px',
            }}
          >
            <Box sx={{ mb: 2 }}>
              <Typography variant="h6">In progress</Typography>
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 'bold',
                fontSize: '24px',
              }}
            >
              {statusCount.inProgressCount}
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <Card
            variant="outlined"
            sx={{
              padding: '16px',
              borderRadius: '12px',
            }}
          >
            <Box sx={{ mb: 2 }}>
              <Typography variant="h6">Assessments on AIs</Typography>
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 'bold',
                fontSize: '24px',
              }}
            >
              {statusCount.assessmentOnAI}
            </Typography>
          </Card>
        </Grid>
      </Grid>

      {/* <CardContent className="risk-management-content">
        <Grid container spacing={2} className="risk-management-grid">
          <Grid xs={12} md={6} item className="vulnerabilities-card">
            <Card variant="outlined">
              <CardHeader title="Vulnerabilities by risk rating" />
              <CardContent className="vulnerabilities-content">
                {!vulnerabilityData ? (
                  <Typography variant="h6" color="text.secondary">
                    No vulnerability data available
                  </Typography>
                ) : (
                  <VulnerabilitiesByRiskRating data={vulnerabilityData} />
                )}
              </CardContent>
            </Card>
          </Grid>

          <Grid xs={12} md={6} item className="residual-card">
            <Card variant="outlined">
              <CardHeader
                title="Residual risk distribution"
                subheader={`Distribution of residual risk levels across ${totalRisks} risks`}
              />
              <CardContent className="residual-content">
                {!residualData ? (
                  <Typography variant="h6" color="text.secondary">
                    No residual risk data available
                  </Typography>
                ) : (
                  <ResidualRiskDistribution data={residualData} />
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </CardContent> */}
    </Card>
  );
};

export default AIRiskManagement;
